var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDrapeau03(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 35 23",
    style: {
      enableBackground: "new 0 0 35 23"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#EEEDEE;}\r\n\t.st1{fill:none;}\r\n\t.st2{fill:#AE1C28;}\r\n\t.st3{fill:#002395;}\r\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\r\n\t.st5{fill-rule:evenodd;clip-rule:evenodd;fill:#AE1C28;}\r\n\t.st6{fill-rule:evenodd;clip-rule:evenodd;fill:#004288;}\r\n\t.st7{fill:#21468B;}\r\n\t.st8{fill:#FFFFFF;}\r\n\t.st9{fill:#DD0000;}\r\n\t.st10{fill:#FFCE00;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "black_stripe",
    width: 35,
    height: 23
  }), /*#__PURE__*/React.createElement("rect", {
    id: "red_stripe",
    y: 7.7,
    className: "st9",
    width: 35,
    height: 15.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "gold_stripe",
    y: 15.3,
    className: "st10",
    width: 35,
    height: 7.7
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrapeau03);
export default __webpack_public_path__ + "static/media/Drapeau03.57fd2ef3876db2febfe8677b02b9062b.svg";
export { ForwardRef as ReactComponent };